import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'

const query = gql`
  mutation ELIMINAR($codigo: String!) {
    tipoArticuloEliminar(codigo: $codigo)
  }
`

export const apiTipoArticuloEliminar = async (codigo: string): Promise<boolean> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)

  const data: any = await client.request(query, { codigo })
  return data.tipoArticuloEliminar
}
